<ng-container *ngIf="!isLoading(); else loading">
  <lib-ad-sponsor-banner
    [entityId]="matchDetailViewService.data?.match?.id"
    [entityType]="entityType"
    [sponsors]="matchDetailViewService.sponsors"
    [lightHeading]="true">
  </lib-ad-sponsor-banner>
  <app-desktop-reporter-matches-card [match]="matchDetailViewService.data.match"></app-desktop-reporter-matches-card>
  <ng-container *ngFor="let entry of this.getEntries(); trackBy: trackItem; let i = index">
    <app-match-live-ticker-activity *ngIf="getPost(entry)"
                                    [post]="getPost(entry)"
                                    [showVertLine]="i > 0"
                                    inViewport
    ></app-match-live-ticker-activity>
    <app-match-live-ticker-activity *ngIf="getActivity(entry)"
                                    [showVertLine]="i > 0"
                                    [activity]="getActivity(entry)"></app-match-live-ticker-activity>
    <lib-ad *ngIf="(i === 0 || (i % 5 === 0 && i > 0))" class="mt-2"></lib-ad>
  </ng-container>
  <button mat-raised-button class="live-ticker-load-more" *ngIf="showLoadMore()" (click)="onLoadMore()">
    Weitere Einträge laden
  </button>
  <div class="nothing-here-yet" *ngIf="showHasNoEntries()">
    <p>Für dieses Spiel sind bisher keine Einträge vorhanden.</p>
  </div>
</ng-container>
<ng-template #loading>
  <div class="mb-1 mt-1">
    <mat-spinner strokeWidth="2" color="primary" diameter="54" class="m-auto"></mat-spinner>
  </div>
</ng-template>
